(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SubcategoryDetailController', SubcategoryDetailController);

    SubcategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Subcategory'];

    function SubcategoryDetailController($scope, $rootScope, $stateParams, entity, Subcategory) {
        var vm = this;
        vm.subcategory = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:subcategoryUpdate', function(event, result) {
            vm.subcategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
